// ValidationBanner — surfaces ValidationIssue[] (F12.2). Presentation.

import type { ValidationIssue } from '@backsolve/shared-types';

export function ValidationBanner({ issues }: { issues: ValidationIssue[] }) {
  const errors = issues.filter((i) => i.severity === 'error');
  const warnings = issues.filter((i) => i.severity === 'warning');
  return (
    <>
      {errors.length > 0 && (
        <div className="validation-banner validation-banner-error" role="alert">
          <div className="validation-banner-title">Errors — must be resolved</div>
          <ul>
            {errors.map((i, idx) => (
              <li key={`${i.code}-${idx}`}>
                <strong>{i.code}</strong>: {i.message}
              </li>
            ))}
          </ul>
        </div>
      )}
      {warnings.length > 0 && (
        <div className="validation-banner validation-banner-warning" role="status">
          <div className="validation-banner-title">Warnings</div>
          <ul>
            {warnings.map((i, idx) => (
              <li key={`${i.code}-${idx}`}>
                <strong>{i.code}</strong>: {i.message}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
